export default __webpack_public_path__ + "static/media/AL.b4f01769.png";